export const HOME_PAGE_ID = 'HOME_PAGE_ID';

export const STEPS_PER_MULTI_INSTALL = 2;
export const STEPS_PER_SINGLE_INSTALL = 4;

export const TIMEOUT_BETWEEN_FAKE_STEPS = 2000;

export const BEFORE_INSTALL_APP_HISTORY_LABEL =
  'BEFORE_INSTALL_APP_HISTORY_LABEL';
export const AFTER_INSTALL_APP_HISTORY_LABEL =
  'AFTER_INSTALL_APP_HISTORY_LABEL';

export const ADD_APP_ERR = 'ADD_APP_ERR';

export const WIDGET_APPS_CONFIG_EXPERIMENT =
  'se_intentInstallWidgetAppsConfiguration';
export const PRE_INTENT_INSTALL_MODAL_EXPERIMENT =
  'se_intentInstallPreInstallModal';
